import { Component, OnInit, HostBinding, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { numSequence } from '@app/shared/utils/num-sequence';

@Component({
  selector: 'app-skeleton-buttons',
  template: `
    <div class="row">
      <app-skeleton-loader
        *ngFor="let num of numSequence(count)"
        [width]="_width"
        [height]="_height"
        [circle]="_isCircle"
        className="mr-4"></app-skeleton-loader>
    </div>
  `,
})
export class SkeletonButtonsComponent implements OnChanges {
  @Input() size = 50;
  @Input() count = 1;
  @Input() appearance: 'circle' | 'square' = 'square';
  _width: string | undefined;
  _height: string | undefined;
  _isCircle = false;

  numSequence = numSequence;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this._width = `${this.size}px`;
    this._height = `${this.size}px`;
    this._isCircle = this.appearance === 'circle';
  }
}
